import { type fabric } from 'fabric';
import { type Constructor } from '../types';
import { zManagerMove, zMoveLayer } from '../utils/zManager';
import { isSimpleSelection } from './guards';

function CanvasLayerBehaviors(Base: Constructor<fabric.Canvas>): any {
  return class extends Base {
    private getObjectsForOperation(object: fabric.Object) {
      if (!object) {
        return [];
      }

      if (object === this._activeObject && isSimpleSelection(object)) {
        return object._objects;
      } else {
        return [object];
      }
    }

    // Send an object to the back of the Z stack.
    sendToBack(object: fabric.Object) {
      const objs = this.getObjectsForOperation(object);
      zManagerMove(objs, 'bottom');
      this.renderOnAddRemove && this.requestRenderAll();
      return this;
    }

    // Bring an object to the front of the Z stack.
    bringToFront(object: fabric.Object) {
      const objs = this.getObjectsForOperation(object);
      zManagerMove(objs, 'top');
      this.renderOnAddRemove && this.requestRenderAll();
      return this;
    }

    // Insert an object into the Z stack at a specific index.
    insertAt(object: fabric.Object, index: number, nonSplicing = false) {
      const targetZ = this._objects[index]?.z;
      super.insertAt(object, index, nonSplicing);
      if (targetZ) {
        zManagerMove([object], { where: 'before', targetZ });
      }
      return this;
    }

    bringForward(obj: fabric.Object) {
      zMoveLayer(obj, 'forward');
      return this;
    }

    sendBackwards(obj: fabric.Object) {
      zMoveLayer(obj, 'backward');
      return this;
    }
  };
}

export default CanvasLayerBehaviors;
